import Typography from '@material-ui/core/Typography';
import React from 'react';

export default function Heading({title}: {title:string}){
	return 	<Typography variant="h4">
		{title}
	</Typography>
}
